import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { sessionStorage } from '@fiverr-private/futile/lib/storage';
import { Provider as TranslationsProvider } from '../providers/i18n';
import ExternalSharing from '../components/ExternalSharing';
import ErrorPage from '../components/ErrorPage';

const Collaboration = ({
    collaboratorId,
    filerrIds,
    contextType,
    contextId,
    linkType,
    unsubscribe,
    showErrorPage,
    locale
}) => {
    useEffect(() => {
        sessionStorage.set('popup-join-shown', true);
    }, []);

    if (showErrorPage) {
        return (
            <TranslationsProvider locale={locale}>
                <ErrorPage/>
            </TranslationsProvider>
        );
    }

    return (
        <ExternalSharing filerrIds={filerrIds}
            collaboratorId={collaboratorId}
            contextType={contextType}
            contextId={contextId}
            linkType={linkType}
            unsubscribe={unsubscribe}
            locale={locale}/>
    );
};

Collaboration.propTypes = {
    filerrIds: PropTypes.array.isRequired,
    collaboratorId: PropTypes.string.isRequired,
    contextId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    contextType: PropTypes.string.isRequired,
    unsubscribe: PropTypes.bool,
    locale: PropTypes.string,
    showErrorPage: PropTypes.bool
};

export default Collaboration;
